import { useQuery } from "@tanstack/react-query";
import { preRegistrationApi } from "./api";

export const usePreRegistrationQuestions = (clientId?: string | null) => {
  return useQuery({
    queryKey: ["pre-registration", "questions", clientId ?? ""],
    queryFn: () => preRegistrationApi.getQuestions({ client_id: clientId }),
    retry: false,
  });
};
